module.exports = __webpack_public_path__ + "img/YaoPin1.87e07002.png";